'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getProductConstraint } from '../../../../../schema/product/entry.js';
import { getEventNumber } from '../../../../../schema/sport/entry.js';
import { useSearchParameters } from '../../lib/hooks/useSearchParameters.js';
import { DrawContext } from './DrawsContext.js';
import { SubscribedDrawContainer } from './SubscribedDrawContainer.js';
/**
 * Draw provider that provides information about the current draw.
 *
 * @param param Props
 * @param param.children Component Children
 * @param param.product Product to load draw for
 * @param param.drawNumber Draw number to load, if not provided it will be loaded from the first opened wager or the first opened draw for the selected date
 * @returns Provider for {@link DrawContext}
 */
export function ResultDrawProvider({ children, product, drawNumber }) {
    const params = useSearchParameters('draw', 'event', 'product');
    const productDrawEventNumber = getEventNumber(1);
    const drawInfo = useMemo(() => {
        let drawNumberToUse;
        let eventNumber = getEventNumber(1);
        // 1. User has entered a correct draw in the query string
        // if (params.draw) { // TODO: support multi draws like Stryktipset
        //   drawNumber = params.draw;
        // }
        // 2. Set first opened draw if empty query string
        if (drawNumber) {
            drawNumberToUse = drawNumber;
        }
        // 1. User has entered a correct event in the query string
        if (params.event) {
            eventNumber = params.event;
        }
        // 2. Set event number from first opened draw if empty query string
        else if (productDrawEventNumber) {
            eventNumber = productDrawEventNumber;
        }
        return {
            product: getProductConstraint(product),
            eventNumber,
            drawNumber: drawNumberToUse,
        };
    }, [params.event, productDrawEventNumber, drawNumber, product]);
    return (_jsxs(DrawContext.Provider, { value: drawInfo, children: [drawInfo.drawNumber ? (_jsx(SubscribedDrawContainer, { product: product, drawNumber: drawInfo.drawNumber, subscriptionType: "FULL" })) : undefined, children] }));
}
//# sourceMappingURL=ResultDrawProvider.js.map